export default {
  title: "CalmSteps",
  view: "View",
  recentViews: "Recently viewed",
  delete: "Delete",
  edit: "Edit",
  done: "Done",
  create: "Create",
  enterCode: "Enter code",
  back: "Back",
  notFound: {
    title: "Not found",
    description: "No view found for code",
  },
  offline: {
    cachedVersion: "Showing cached version",
    notAvailable: "Not available offline",
    notAvailableDescription: "Open this view online first to enable offline access.",
  },
};
